import $ from "jquery";
import vuwer from "@@assets/scripts/vuwer";

const vuwBody = vuwer.get("body");
!!vuwBody && vuwBody.onReady($body => {
	$body.on("click", ".toggle-accordion", e => {
		e.preventDefault();
		
		const $trigger = $(e.currentTarget);
		const $target = $trigger.next();
		if($target.length) {
			const duration = parseInt( $target.data("duration") ) || 250;
			$trigger.css({
				"transition-duration": `${duration * 1.2 / 1000}s`
			}).toggleClass("is-open");
			
			const method = $trigger.hasClass("is-open") ? "Down" : "Up";
			$.fn[`slide${method}`].call($target, duration);
		}
	});
});
